import { render } from "./KaiJsp.vue?vue&type=template&id=767bd39e&scoped=true"
import script from "./KaiJsp.vue?vue&type=script&lang=js"
export * from "./KaiJsp.vue?vue&type=script&lang=js"

import "./KaiJsp.vue?vue&type=style&index=0&id=767bd39e&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_9acfb15ce118456a03f39fb117bb0076/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767bd39e"]])

export default __exports__